import React from "react";

import { graphql, useStaticQuery } from "gatsby";
import PropTypes from "prop-types";

import useLanguage from "../hooks/useLanguage";
import BrowserDetection from "../utils/browserDetection";

const SEO = ({
  title,
  description = "",
  isHiddenForRobots = false,
  keywords = [],
  lang = null,
  ogDescription = "",
  ogImage = [],
  ogTitle = "",
  twitterCreator = "",
  twitterDescription = "",
  twitterImage = [],
  twitterSite = "",
  twitterTitle = "",
}) => {
  const data = useStaticQuery(graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `);

  const { languageCode } = useLanguage();

  // const languageCode = "en";

  const metaDescription = description || data.site.siteMetadata.description;

  let browserList = "";

  browserList += BrowserDetection.hasTouchScreen() ? "touchable " : "";
  browserList += BrowserDetection.isIE() ? "ie " : "";

  return (
    <>
      <html className={browserList.trim()} lang={lang || languageCode || "en"} />
      <title>{title}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage.length > 0 ? `${ogImage[0].url}?h=630&w=1200` : ""} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={twitterCreator || data.site.siteMetadata.author} />
      <meta name="twitter:site" content={twitterSite} />
      <meta name="twitter:image" content={twitterImage.length > 0 ? `${twitterImage[0].url}?h=630&w=1200` : ""} />
      <meta name="twitter:title" content={twitterTitle || title} />
      <meta name="twitter:description" content={twitterDescription || metaDescription} />

      <meta name="robots" content={isHiddenForRobots ? "noindex,nofollow" : "index,follow"} />

      {keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(", ")} />
      )}
    </>
  );
};

SEO.propTypes = {
  description: PropTypes.string,
  isHiddenForRobots: PropTypes.bool,
  keywords: PropTypes.arrayOf(PropTypes.string),
  lang: PropTypes.string,
  ogDescription: PropTypes.string,
  ogImage: PropTypes.oneOfType([PropTypes.array]),
  ogTitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  twitterCreator: PropTypes.string,
  twitterDescription: PropTypes.string,
  twitterImage: PropTypes.oneOfType([PropTypes.array]),
  twitterSite: PropTypes.string,
  twitterTitle: PropTypes.string,
};

export default SEO;
